import React from "react";
import classNames from "classnames";
import GrComponentFactory from "../gr_component_factory";
import GrPropTypes from "../shared/gr_prop_types";
import SocialUpdate from "./social_update";
import BookWithWTRButton from "../book_with_wtr_button";
import BookDescription from "../book_description";
import Book, { VALID_BOOK_SIZES } from "../book";

export default GrComponentFactory.createClass({
  displayName: "SocialBookUpdate",
  /*
    Prop Types:
    header: A React element that is rendered in the header portion of the newsfeed
      update.
    bookBody: A React element that is rendered underneath the WTR button in the
      Book + WTR Button portion of the newsfeed update body.
    updateDetails: A React element that is rendered above the Book + WTR Button
      portion of the newsfeed update body.
  */
  propTypes: {
    header: React.PropTypes.element.isRequired,
    book: GrPropTypes.book().isRequired,
    bookBody: React.PropTypes.element,
    bookLabel: React.PropTypes.element,
    updateDetails: React.PropTypes.element,
    additionalFooterLinks: React.PropTypes.arrayOf(React.PropTypes.element),
    showBookBorder: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      includeWTR: true,
      showBookBorder: false,
    };
  },

  renderBookBody() {
    if (this.props.bookBody) {
      return this.props.bookBody;
    } else {
      return (
        <BookDescription className="u-marginTopXSmall" bookDescription={this.props.book.description} />
      );
    }
  },

  renderUpdateDetails() {
    if (this.props.updateDetails) {
      return (
        <div className="gr-newsfeedItem__socialBookUpdateDetails">
          {this.props.updateDetails}
        </div>
      );
    } else {
      return null;
    }
  },

  renderBody() {
    const bookClassName = classNames({ "gr-book--border": this.props.showBookBorder });
    return (
      <div>
        {this.renderUpdateDetails()}
        { this.props.includeWTR ?
            <BookWithWTRButton {...this.props} bookClassName={bookClassName} body={this.renderBookBody()}/> :
            <Book {...this.props.book}
                  className={this.props.bookClassName}
                  label={this.props.bookLabel}
                  size={VALID_BOOK_SIZES.LARGE}>
              {this.renderBookBody()}
            </Book>
        }
      </div>
    );
  },

  render() {
    return <SocialUpdate
      {...this.props}
      header={this.props.header}
      body={this.renderBody()}
      />;
  },
});
